(() => {
    const createImg = (src = '', altText = '') => `<img class="img-fluid" src="${src}" alt="${altText}"/>`;
    const createVideo = (src = '') => `<div class="video-wrapper"><iframe class="product-details__main-video" src="${src}?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>`;
    const createModal = (title = '', content = '') => {
        var html = '<div id="imagePopUpModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="confirm-modal" aria-hidden="true">';
        html += '<div class="modal-dialog modal-lg">';
        html += '<div class="modal-content">';
        html += '<div class="modal-header">';
        html += '<h4>' + title + '</h4>';
        html += '<a class="close" data-dismiss="modal" role="button" tabindex="0">×</a>';
        html += '</div>';
        html += '<div class="modal-body text-center">';
        html += content;
        html += '</div>';
        html += '</div>';  // dialog
        html += '</div>';  // footer
        html += '</div>';  // modalWindow
        $('body').append(html);
        $("#imagePopUpModal").modal();
        $("#imagePopUpModal").modal('show');

        $('#imagePopUpModal').on('hidden.bs.modal', function (e) {
            $(this).remove();
        });
        $('#imagePopUpModal').on('shown.bs.modal', function (e) {
            $('#imagePopUpModal .modal-header .close').keypress(function (event) {
                var key = event.which;
                if (key == 13 || key == 32) {
                    $(this).trigger('click');
                    event.preventDefault();
                }
            });
        });

    }

    const onJsSlideModalClick = (e) => {
        e.preventDefault();

        const {
            slideModalTitle,
            slideModalType = 'image',
            slideModalUrl,
            slideModalAlt,
        } = e.currentTarget.dataset;

        let content = '';

        switch (slideModalType) {
            case 'image':
                content = createImg(slideModalUrl, slideModalAlt);
                break;
            case 'video':
                content = createVideo(slideModalUrl);
                break;
            default:
                content = createImg(slideModalUrl, slideModalAlt);
        }

        // Clean up lingering modals in case user is too fast
        $('#imagePopUpModal').next('.modal-backdrop').remove(); 
        $('#imagePopUpModal').remove();

        createModal(slideModalTitle, content);
    }
    
    const onJsImageCellModalClick = (e) => {
        e.preventDefault();

        const {
            url,
            containerCode,
        } = e.currentTarget.dataset;
        
        var imageContainer = $('#imageContainer-' + containerCode);
        var videoContainer = $('#videoContainer-' + containerCode);
        var imageModalSelector = '#imagePopUpModal-' + containerCode;
        
        imageContainer.removeClass('d-none');
        videoContainer.parent().addClass('d-none');
        
        imageContainer.attr("src",url);
        
        $(imageModalSelector + " .image-cell").removeClass('cell-border');
        
        $(e.currentTarget).addClass('cell-border');
        
    }

    const onJsVideoCellModalClick = (e) => {
        e.preventDefault();

        const {
            url,
            containerCode,
        } = e.currentTarget.dataset;

        var imageContainer = $('#imageContainer-' + containerCode);
        var videoContainer = $('#videoContainer-' + containerCode);
        var imageModalSelector = '#imagePopUpModal-' + containerCode;
        var videoWrapper = $(imageModalSelector + " .video-wrapper");

        imageContainer.addClass('d-none');
        $(imageModalSelector + " .image-cell").removeClass('cell-border');

        videoContainer.remove();
        videoContainer.attr("src", url);
        videoWrapper.append(videoContainer);
        videoWrapper.removeClass('d-none');
        $(e.currentTarget).addClass('cell-border');
    }

    const closeVideo = (e) => {
        let imageModalId = e.currentTarget.id;
        let splitImageModalId = imageModalId && imageModalId.split("-");
        let containerCode = splitImageModalId && splitImageModalId.length > 1 && imageModalId.split("-")[1];
        let videoContainer = $('#videoContainer-' + containerCode);
        
        if (videoContainer) videoContainer.attr("src", "");
    }

    $(document).ready(() => {
        $('.js-slide-modal').on('click.slideModal', onJsSlideModalClick);
        $('.js-image-cell-modal').on('click', onJsImageCellModalClick);
        $('.js-video-cell-modal').on('click', onJsVideoCellModalClick);
        $('.flickity-slider').on('DOMNodeInserted', () => {
            $('.js-slide-modal')
                .off('.slideModal')
                .on('click.slideModal', onJsSlideModalClick);
        });

        $('.js-image-modal').on('show.bs.modal', (e) => {
            $(`.js-image-modal .image-cell[data-image-url='${$(e.relatedTarget).attr('data-image-url')}']`).click();
        })
        $('.js-image-modal').on('shown.bs.modal', (e) => {
            window.history.pushState(null, null, window.location.href)
        })
        $('.js-image-modal').on('hidden.bs.modal', closeVideo);
        $(window).on('popstate', () => {
           let imageModal = $(".js-image-modal");
           if (imageModal) {
               imageModal.modal('hide');
           }
        });
    });

})();